module.exports = __webpack_public_path__ + "img/ro.cf3dcce9.png";